<template>
  <v-autocomplete
    ref="input"
    :value="value"
    :items="items"
    :loading="loading"
    :item-text="itemText"
    :search-input.sync="search"
    :placeholder="placeholder"
    return-object
    no-filter
    hide-no-data
    hide-details
    single-line
    @change="onChange"
  />
</template>

<script>
// Reusable async autocomplete for the Event Request Form. Each instance owns its
// own search text, results, and loading state so per-row product/store fields
// search independently. The parent passes a `fetch` function (query -> Promise
// of an items array) and listens for `selected` to react to a choice. When
// `allowCreate` is set, a trailing "Add '<typed>' as a new item" option appears
// and firing it emits `create` with the raw typed text.
export default {
  name: 'AsyncAutocomplete',

  props: {
    value: { default: null },
    fetch: { type: Function, required: true },
    itemText: { type: String, default: 'name' },
    placeholder: { type: String, default: '' },
    allowCreate: { type: Boolean, default: false }
  },

  data: () => ({
    search: '',
    items: [],
    loading: false,
    timer: null
  }),

  watch: {
    // Debounce the typed query, then delegate the lookup to the parent's fetch
    search (val) {
      clearTimeout(this.timer)
      if (!val || val.length < 2) { this.items = []; return }
      if (this.value && val === this.value[this.itemText]) return
      this.timer = setTimeout(() => {
        this.loading = true
        this.fetch(val)
          .then(items => {
            const results = items || []
            // Offer a create-new option using exactly what the user typed
            if (this.allowCreate && val) {
              const option = { __new: true, query: val }
              option[this.itemText] = 'Add "' + val + '" as a new item'
              results.push(option)
            }
            this.items = results
          })
          .catch(err => console.error('autocomplete fetch failed', err))
          .then(() => { this.loading = false })
      }, 250)
    }
  },

  methods: {
    focus () {
      if (this.$refs.input && this.$refs.input.focus) this.$refs.input.focus()
    },

    onChange (val) {
      if (val && val.__new) {
        this.$emit('create', val.query)
      } else {
        this.$emit('input', val)
        this.$emit('selected', val)
      }
    }
  }
}
</script>
